import reflectionsFilterGif from "@assets/reflections-filter.gif";
import { FaroBetaBadge } from "@components/common/faro-beta-badge";
import { FaroPopover, FaroText } from "@faro-lotv/flat-ui";
import { Box, Stack } from "@mui/material";
import { sphereColors } from "@styles/common-colors";

interface Props {
  /** Reference to the popover anchor element. */
  popoverRef: React.MutableRefObject<HTMLDivElement | HTMLAnchorElement | null>;
  /** Flag to control the visibility of the popover. */
  isShowPopover: boolean;
  /** Callback to set the visibility of the popover. */
  setIsShowPopover: React.Dispatch<React.SetStateAction<boolean>>;
}

/** Popover that displays the supported data types for the import. */
export function ReflectionFilterPopover({
  popoverRef,
  isShowPopover,
  setIsShowPopover,
}: Props): JSX.Element {
  return (
    <FaroPopover
      dark
      anchorEl={popoverRef.current}
      open={isShowPopover}
      onClose={() => setIsShowPopover(false)}
      title={
        <FaroText
          variant="labelM"
          color={sphereColors.pureWhite}
          sx={{ textTransform: "uppercase" }}
        >
          Reflection filter
        </FaroText>
      }
      chipLabel={
        <Box sx={{ display: "flex" }}>
          <FaroBetaBadge/>
        </Box>
      }
      showCloseButton={false}
      description={
        <Stack>
          <Box
            mt={1}
            mb={1}
            sx={{
              textAlign: "center",
            }}
          >
            {/* Fixed size so that FaroPopover correctly opens to the top/bottom according available space. */}
            <img
              src={reflectionsFilterGif}
              alt="Reflection Filter Demo GIF"
              style={{ width: "280px", height: "219px" }}
            />
          </Box>

          <FaroText
            color={sphereColors.pureWhite}
            variant="bodyS"
          >
            Enabling the reflection filter may increase processing time. If there are no reflective surfaces
            (e.g. windows, mirrors), disabling it can save time and resources.
          </FaroText>
        </Stack>
      }
    />
  );
}
